// extracted by mini-css-extract-plugin
export default {"select":"FontSizeSelector_select__eQGjr"};